import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { RendererSelectorComponent } from '../../renderer-selector.component';
import { BaseCrmModelDrivenFormComponent } from './base-model-driven-form.component';
import { CrmFormLoadingIndicatorComponent } from './form-loading-indicator.component';
import { CrmFormButtonGroupComponent } from './form-button-group.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ObjectType } from '../../../../tokens-and-interfaces';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { RendererSelectorService } from '../../renderer-selector.service';
import { ValidatorFactoryService } from '../../validator-factory.service';
import { InlineEditService } from '../../inline-edit.service';
import { ScoreService } from '../../../../shared-services';
import { CrmInjectionToken, CrmDependencies } from '../../../../tokens-and-interfaces';
import { TranslateByObjectTypePipe } from '../../../../i18n/translate-by-object-type/translate-by-object-type.pipe';
import {
  CrmFieldService,
  StandardIds,
  StandardExternalIds,
} from '../../../../shared-services/crm-services/field.service';

@Component({
  selector: 'crm-basic-field-group-form',
  templateUrl: './basic-field-group-form.component.html',
  styleUrls: ['./base-model-driven-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TranslateByObjectTypePipe,
    GalaxyEmptyStateModule,
    MatIconModule,
    RendererSelectorComponent,
    MatCardModule,
    CrmFormLoadingIndicatorComponent,
    CrmFormButtonGroupComponent,
    MatButtonModule,
    MatDialogModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CrmBasicFieldGroupFormComponent extends BaseCrmModelDrivenFormComponent {
  basicGroupFieldsMap = new Map<ObjectType, string[]>([]);

  constructor(
    @Inject(CrmInjectionToken) protected override readonly config: CrmDependencies,
    protected override snackService: SnackbarService,
    protected override rendererSelector: RendererSelectorService,
    protected override readonly validatorFactory: ValidatorFactoryService,
    protected override readonly inlineEditService: InlineEditService,
    protected readonly fieldService: CrmFieldService,
    protected override readonly scoreService: ScoreService,
  ) {
    super(config, snackService, rendererSelector, validatorFactory, inlineEditService, fieldService, scoreService);

    this.basicGroupFieldsMap.set('Contact', [
      fieldService.getFieldId(StandardExternalIds.FirstName),
      fieldService.getFieldId(StandardExternalIds.LastName),
      fieldService.getFieldId(StandardExternalIds.PhoneNumber),
      fieldService.getFieldId(StandardExternalIds.Email),
      fieldService.getFieldId(StandardExternalIds.Tags),
      StandardIds.ContactLinkedInURL,
      StandardIds.ContactJobTitle,
    ]);
    this.basicGroupFieldsMap.set('Company', [
      StandardIds.CompanyName,
      StandardIds.CompanyWebsite,
      StandardIds.CompanyPrimaryAddressLine1,
      StandardIds.CompanyPrimaryAddressLine2,
      StandardIds.CompanyPrimaryAddressCity,
      StandardIds.CompanyPrimaryAddressState,
      StandardIds.CompanyPrimaryAddressPostalCode,
      StandardIds.CompanyPrimaryAddressCountry,
      StandardIds.CompanyPhoneNumber,
      StandardIds.CompanyTags,
    ]);
  }
}
